import { z } from 'zod';

export const iconCategorySchema = z.enum([
  'combat',
  'build',
  'facility',
  'logistic',
  'navy',
  'op_info',
  'op_attack',
  'op_defend',
  'op_arty',
  'op_build',
  'op_navy',
  'op_unit',
  'op_vehicle',
]);
export type IconCategoryDTO = z.infer<typeof iconCategorySchema>;

export const mapModeSchema = z.enum(['planner', 'operation']);
export type MapModeDTO = z.infer<typeof mapModeSchema>;

/** Stable icon id (matches a PNG file under `apps/web/public/11eIcons/`). */
export const iconIdSchema = z
  .string()
  .min(2)
  .max(64)
  .regex(/^[A-Z][A-Z0-9_]+$/, 'iconId must be UPPER_SNAKE_CASE');

export const mapPositionSchema = z.object({
  x: z.number().finite(),
  y: z.number().finite(),
});
export type MapPositionDTO = z.infer<typeof mapPositionSchema>;

export const markerMetadataSchema = z.object({
  iconId: iconIdSchema,
  note: z.string().max(2000).optional(),
  scale: z.number().min(1.0).max(1.5).optional(),
});
export type MarkerMetadataDTO = z.infer<typeof markerMetadataSchema>;

export const mapObjectSchema = z.object({
  id: z.string().uuid(),
  kind: iconCategorySchema,
  position: mapPositionSchema,
  metadata: markerMetadataSchema,
  mode: mapModeSchema,
  updatedAt: z.string().datetime(),
  deletedAt: z.string().datetime().nullable().optional(),
});
export type MapObjectDTO = z.infer<typeof mapObjectSchema>;

export const createMapObjectSchema = z.object({
  kind: iconCategorySchema,
  position: mapPositionSchema,
  metadata: markerMetadataSchema,
  mode: mapModeSchema.optional(),
});
export type CreateMapObjectInput = z.infer<typeof createMapObjectSchema>;

export const patchMapObjectSchema = z
  .object({
    kind: iconCategorySchema.optional(),
    position: mapPositionSchema.optional(),
    metadata: markerMetadataSchema.optional(),
    mode: mapModeSchema.optional(),
  })
  .refine((p) => Object.keys(p).length > 0, {
    message: 'Patch must include at least one field',
  });
export type PatchMapObjectInput = z.infer<typeof patchMapObjectSchema>;

export const listMapObjectsResponseSchema = z.object({
  objects: z.array(mapObjectSchema),
});
export type ListMapObjectsResponse = z.infer<typeof listMapObjectsResponseSchema>;
